module.exports = require('./helpers/bundle-url').getBundleURL('6gjun') + "../images/dot-rb.bf9ffcfe..png" + "?" + Date.now();